import React from 'react';
import './outline.scss';


function OutlineCard(props) {
    return (
        <div className="outline-card">
            <div className='num'>{props.data.num}</div>
            <div className='title'>{props.data.title}</div>
            <div className='desc'>
                {
                    props.data.desc.map((item, index) => {
                        return <span key={index}>{item}</span>
                    })

                }
            </div>
            <embed src={props.data.icon} type="image/svg+xml"/>
        </div>
    );
}

export default OutlineCard;
